// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xRv8","badges":"styles_badges__1Zrou"};